<script>
export default {
  data() {
    return {
      items: [
        {
          name: 'admin-finance-catalog',
          title: this.$t('finance_nav.setting'),
        },
        {
          name: 'admin-finance-fund-list',
          title: this.$t('finance_nav.breakdown_of_funds'),
        },
        {
          name: 'admin-finance-return-list',
          title: this.$t('finance_nav.return_history'),
        },
        {
          name: 'admin-finance-dividend-list',
          title: this.$t('finance_nav.dividend_details'),
        },
      ],
    }
  },
}
</script>

<template>
  <ul :class="$style.localNavigation">
    <router-link
      v-for="{ name, title } in items"
      :key="name"
      :to="{ name, params: $route.params }"
      :active-class="$style.on"
      tag="li"
    >
      <a href="#" @click.prevent>{{ title }}</a>
    </router-link>
  </ul>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
</style>
+
